import {currentState, fireTransition, possibleTransitions} from './workflow';

export const workflow = {
    currentState,
    fireTransition,
    possibleTransitions,
};
